/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DecryptTextCommand } from '../models/DecryptTextCommand';
import type { EncryptTextCommand } from '../models/EncryptTextCommand';
import type { EncryptTextResponse } from '../models/EncryptTextResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class CryptoControllerService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * @returns EncryptTextResponse OK
   * @throws ApiError
   */
  public encrypt({
    requestBody,
  }: {
    requestBody: EncryptTextCommand,
  }): CancelablePromise<EncryptTextResponse> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/crypto/encrypt',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @returns string OK
   * @throws ApiError
   */
  public decrypt({
    requestBody,
  }: {
    requestBody: DecryptTextCommand,
  }): CancelablePromise<Array<string>> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/crypto/decrypt',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
}
